import { Link } from "react-router-dom";
import { ArrowUpRight, MessageSquarePlus, QrCode } from "lucide-react";
import { Stars } from "./Stars";
import { photoSrc } from "../lib/api";

export const WasherCard = ({ washer, index, onReview, onQr }) => (
  <article
    data-testid={`washer-card-${washer.id}`}
    className="rise group overflow-hidden rounded-3xl border border-white/[0.07] bg-[#131B26] transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#00F0FF]/40"
    style={{ animationDelay: `${index * 90}ms` }}
  >
    <Link to={`/spalator/${washer.id}`} className="relative block aspect-[4/3] overflow-hidden bg-slate-800">
      {washer.photo_url && (
        <img src={photoSrc(washer.photo_url)} alt={washer.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#131B26] via-transparent to-transparent" />
      <span className="absolute right-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-black/50 text-white backdrop-blur-md transition-colors group-hover:bg-[#00F0FF] group-hover:text-[#090E17]">
        <ArrowUpRight size={18} />
      </span>
    </Link>
    <div className="space-y-4 p-6">
      <div>
        <h3 className="font-display text-2xl font-semibold tracking-tight" data-testid={`washer-name-${washer.id}`}>{washer.name}</h3>
        {washer.bio && <p className="mt-1 line-clamp-2 text-sm text-slate-400">{washer.bio}</p>}
      </div>
      <div className="flex items-center gap-3" data-testid={`washer-rating-${washer.id}`}>
        <span className="font-display text-3xl font-bold">{washer.review_count ? washer.avg_rating.toFixed(1) : "–"}</span>
        <div>
          <Stars value={washer.avg_rating} />
          <p className="text-xs text-slate-500">{washer.review_count} {washer.review_count === 1 ? "recenzie" : "recenzii"}</p>
        </div>
      </div>
      <div className="flex gap-2">
        <button onClick={() => onReview(washer)} data-testid={`washer-review-btn-${washer.id}`}
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#00F0FF] py-3 text-sm font-semibold text-[#090E17] transition-colors hover:bg-[#33F3FF]">
          <MessageSquarePlus size={17} /> Lasă o recenzie
        </button>
        <button onClick={() => onQr(washer)} data-testid={`washer-qr-btn-${washer.id}`} aria-label="Cod QR"
          className="grid w-12 place-items-center rounded-full border border-white/10 text-slate-300 transition-colors hover:border-[#00F0FF]/60 hover:text-white">
          <QrCode size={18} />
        </button>
      </div>
    </div>
  </article>
);
